import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyNewsContent.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const AgencyNewsContent = () => {
    const {tab} = useParams();
    const navigate = useNavigate();
    // const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [recentPosts, setRecentPosts] = useState([]);
    const [mainNewsContent, setMainNewsContent] = useState({});
    const [socialMediaShare, setSocialMediaShare] = useState([]);
    const [submitStatus, setSubmitStatus] = useState(null);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [toggle, setToggle] = useState(1);
    const[successBlogMessage,setSuccessMessage] = useState('');
const app_url = configData.APP_URL; 
    const initialFormData = {
              email:'',
              first_name:'',
              last_name:'',
              phone:'',
              pageURL:window.location.href
            };
    const [formData,setFormData] =useState(initialFormData);
    const [errors, setErrors] = useState({});
            const {slug} = useParams();

        // const {id} = useParams();

            function updateToggle(id){
                setToggle(id);
        
                if(id == 1) { 
                //  navigate(`/content/${rid}`);
                 navigate("/blog-content/"+slug);
                }
                if(id == 2) { 
                navigate(
                    "/blog-content/"+mainNewsContent?.id+"/edit"
                );
                }
                
            }

    useEffect(() => {
        // const staticData = {
        //     img: "/basic/web/images/agent/Michael-Collier-PWHL-Certified-Agent.png",
        //     title: "SMWW Hockey Agency Director Michael Collier Earns PWHLPA Player Agent Certification",
        //     date: "October 20, 2025",
        //     authorName: "Dr. Lynn Lashbrook",
        //     authorURL: "users/dr-lynn-lashbrook",
        //     newsContent: `<p>SMWW Agency is proud to announce that <a href="https://www.smwwagency.com/agent/michael-collier"><strong>Michael Collier</strong></a>, <strong>SMWW's</strong>&nbsp;<strong>Hockey Agency Director</strong>, has officially been certified as a <strong>Licensed Player Agent with the Professional Women’s Hockey League Players Association (PWHLPA)</strong>.</p><p>This achievement marks a significant milestone for both Michael and SMWW, positioning our organization as a leader in the representation of female hockey players worldwide. Michael’s certification expands SMWW’s reach within the rapidly growing landscape of women’s professional hockey, reinforcing our commitment to supporting athletes at every level of the game.</p><p>In addition to his new PWHLPA accreditation, Michael currently represents two female hockey players, as well as a Russian goaltender in collaboration with a KHL agency. His dedication to player development and representation continues to strengthen SMWW’s presence across the global hockey industry.</p>`,
        //     shareUrl: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",

        // };
        // setMainNewsContent(staticData);

        const socialMedia = {
            facebookUrl: "https://www.facebook.com/sharer.php?u=",
            linkedinUrl: "https://www.linkedin.com/shareArticle?url=",
            twitterUrl: "https://twitter.com/intent/tweet?url=",
        }
        setSocialMediaShare(socialMedia);   
    },[]);
    const fakeApiCall = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      Math.random() > 0.7
        ? reject(new Error("network"))
        : resolve();
    }, 1000);
  });
};
 const location = useLocation();
    const successMessage = location.state?.message;
   
 useEffect(() => {
          if (successMessage) {
            setSuccessMessage(successMessage);
            window.history.replaceState({}, '');
          }
        }, [successMessage, location.state]);

  
    useEffect(() => {
        Promise.all([
            getblogdetailedview(),
            getuserloggedinroles(),
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    async function getuserloggedinroles() {
   
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
  }   

    async function  getblogdetailedview() {
    if(slug) {
       try {
        
    const response = await fetch(
      app_url+'smwwblog/retrieveblogdetails?slug='+slug,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
        setMainNewsContent(responsedata.data.result);
        setRecentPosts(responsedata.data.recentPosts);
      //setBioDetails(responsedata.data.result);
    }
    if(responsedata.data.msg === "Error") {
      //setErrorText(responsedata.data.result);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
const handleChange = (e) => {
    const { name, value } = e.target;    
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));  
};
const isValidBasicPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  return cleaned.length >= 7 && cleaned.length <= 15;
};

const validateForm = () => {
  const newErrors = {};

if (!formData.email) {
  newErrors.email ="Email Address field is required.";
} else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
  newErrors.email ="Invalid Email Format.";
}

if (formData.phone) {
    if(formData.phone.trim()) {
  if (!isValidBasicPhone(formData.phone)) {
    newErrors.phone ="Invalid Phone Number";
  }
}
}
 
 
    // CAPTCHA Validation
// if (!formData.captcha_response) {
//   newFieldErrors.captcha_response = true;
//   newMessages.push('What code is in the image? field is required.');
// } else if (formData.captcha_response.trim() !== captchaText.trim()) {
//   newFieldErrors.captcha_response = true;
//   newMessages.push('The CAPTCHA code entered is incorrect.');
// }
return newErrors;
};
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (validateForm()) {
    // const response = await fetch(app_url+'smwwathlete/athletelookingforagent', {
    //   method: 'POST',
    //   body: JSON.stringify(formData),
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   });
    //   const data = await response.json();
    //    if(data.data.result === "user_created") {
    //      setSuccess("Form submitted successfully!");
    //       setErrors([]);
    //        setFormData(initialForm);

    //       window.scrollTo(0, 0);
      // }
    //    else if(data.data.result === "error") {
        
    //     window.scrollTo(0, 0);
    //    }

//   }
//    else {
      
//       window.scrollTo(0, 0);
//     }
// };
const handleSubmit = async (e) => {
  e.preventDefault();

  const errors = validateForm();

  if (Object.keys(errors).length > 0) {
    setErrors(errors);
    setSubmitStatus(null);
    return;
  }

  try {
    // simulate API call
     const response = await fetch(app_url+'smwwblog/application', {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json',
             },
            });
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setErrors({});
                setSubmitStatus("success");
               
            }
             if(responsedata.data.msg === "Error") {
                setErrors(responsedata.data.result);
            }
     
    
  } catch (err) {
    if (err.message === "network") {
      setSubmitStatus("network");
    } else {
      setSubmitStatus("error");
    }
  }
};



    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="smww-agency-news-content-main">
                <Helmet><title>SMWW Hockey Agency Director Michael Collier Earns PWHLPA Player Agent Certification </title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                     {successBlogMessage && (
                <div className="set-message-done">
                  <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successBlogMessage}
                </div>
              )}
                    {( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                          <a style={{cursor: "pointer"}}>View</a>
                        </li>
                      
                        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                          <a style={{cursor: "pointer"}}>Edit</a>
                        </li>
                        {/* )} */}
                      </ul>
                    }

                    <div className="container smw-st-blog"> 
                        <header className="hero">
                            <img src={mainNewsContent.img} style={{"margin": "0 auto"}}/>
                        </header>
                        <div className="headline-wrapper">
                            <h2 className="subheadline"></h2>
                        </div>
                    </div>	
                    <div className="container ds smw-st-blog">
                        <div className="col-md-9">
                            <h1 className="my-4">{mainNewsContent.title}
                            <br/>
                            <small>
                                {mainNewsContent.date} 
                                &nbsp;by&nbsp; 
                                <span className="author">
                                    <a style={{"color":"#99d888"}} target="_blank" href={mainNewsContent.authorURL}>{mainNewsContent.authorName}</a>
                                </span>
                            </small>
                            </h1>
                            <div className="blog_body_details">
                                <div className="column1">
                                <span style={{"color":"#003c7d"}}><b>SHARE</b></span><br/><br/>
                                    <a target="_blank" href={socialMediaShare.facebookUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}>
                                        <img className=" lazyloaded" src="/basic/web/images/fb_blog_red.png" />
                                    </a><br/><br/>
                                    <a target="_blank" href={socialMediaShare.linkedinUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}>
                                        <img className=" lazyloaded" src="/basic/web/images/linkedin_blog_red.png" />
                                    </a><br/><br/>
                                    <a target="_blank" href={socialMediaShare.twitterUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}>
                                        <img className=" lazyloaded" src="/basic/web/images/twitter_blog_red.png" />
                                    </a><br/><br/>
                                </div>
                                <div className="column2">
                                    <div dangerouslySetInnerHTML={{ __html: mainNewsContent.newsContent }} />
                                </div>
                            </div>      
                        </div>
                        <div class="col-md-3 gs">
                            <div className="card my-4 ms-bg-bl des-bord">
                                <h5 className="card-header post-sidebar-heading">Recent Posts</h5>
                                <hr />

                                <ul className="list-unstyled mb-0">
                                    {recentPosts.map((post, index) => (
                                    <div key={post.id}>
                                        <li style={{ listStyleType: "none", listStyle: "none" }}>
                                        <a href={post.link}>
                                            <img src={post.img} alt={post.title} />
                                            <p className="stwwt-post-title">{post.title}</p>
                                        </a>
                                        </li>

                                        {/* Add <hr> except after last item */}
                                        {index !== recentPosts.length - 1 && <hr />}
                                    </div>
                                    ))}
                                </ul>
                            </div>
                            <div className="card my-4 ms-bg-bl bg-sta-wrapper">
                                <h5 className="card-header post-sidebar-heading">Newsletter Signup</h5>
                                <hr/>
                                <div id="newsletter_wrapper">
                                    {/* Begin Constant Contact Inline Form Code  */}
                                    <div className="ctct-inline-form">
                                        <div className="ctct-form-container ctct-form-embed form_2">
                                            <div className="ctct-form-defaults">
                                                {submitStatus === "success" ? (
                                                <div id="success_message_2" className="ctct-form-success">
                                                    <h2 className="ctct-form-header">Thanks for signing up!</h2>
                                                    <p className="ctct-form-text">You can unsubscribe at any time using the Unsubscribe link at the bottom of every email.</p>
                                                </div>
                                                ) : (
                                                <form className="ctct-form-custom" id="ctct_form_2" autocomplete="on" noValidate onSubmit={handleSubmit}>
                                                    <div id="email_address_field_2" className="ctct-form-field">
                                                        <div style={{display:"flex"}}><span className="form-required" title="This field is required.">*</span>&nbsp;
                                                            <label id="email_address_label_2" for="email_address_2" class="ctct-form-label ctct-form-required">Email</label>
                                                        </div>
                                                        <div className="ctct-form-errorMessage"></div>
                                                        <input className="ctct-form-element" id="email_address_2" type="email" name="email" value={formData.email} maxLength="80" onChange={handleChange}/>
                                                        {errors.email &&
                                                        <span className="error-message" style={{marginTop:"0px"}}>
                                                        {errors.email}
                                                        </span>
                                                        } 
                                                    </div>
                                                    
                                                    <div id="first_name_field_2" className="ctct-form-field">
                                                        <label id="first_name_label_2" for="first_name_2" class="ctct-form-label ">First Name</label>
                                                        <div className="ctct-form-errorMessage"></div>
                                                        <input className="ctct-form-element" id="first_name_2" type="text" name="first_name" value={formData.first_name} maxLength="50" onChange={handleChange}/>
                                                    </div>
                                                    
                                                    <div id="last_name_field_2" className="ctct-form-field">
                                                        <label id="last_name_label_2" for="last_name_2" className="ctct-form-label ">Last Name</label>
                                                        <div className="ctct-form-errorMessage"></div>
                                                        <input className="ctct-form-element" id="last_name_2" type="text" name="last_name" value={formData.last_name} maxLength="50" onChange={handleChange}/>
                                                    </div>
                                                    
                                                    <div id="phone_field_2" className="ctct-form-field">
                                                        <label id="phone_label_2" for="phone_2" className="ctct-form-label ">Phone</label>
                                                        <div className="ctct-form-errorMessage"></div>
                                                        <input className="ctct-form-element" id="phone_2" type="tel" name="phone" value={formData.phone} maxLength="50" onChange={handleChange}/>
                                                        {errors.phone &&
                                                        <span className="error-message" style={{marginTop:"0px"}}>
                                                        {errors.phone}
                                                        </span>
                                                        } 
                                                    </div>
                                                    {submitStatus === "error" && (
                                                    <div id="error_message_2" className="ctct-form-error">
                                                        <p className="ctct-form-errorMessage">Sorry, we could not complete your sign-up. Please contact us to resolve this.</p>
                                                    </div>
                                                    )}
                                                    {submitStatus === "network" && (
                                                    <div id="network_error_message_2" className="ctct-form-error">
                                                        <p className="ctct-form-errorMessage">Operation timed out, please try again.</p>
                                                    </div>
                                                    )}
                                                    <div id="gdpr_text">
                                                        <p className="ctct-gdpr-text">
                                                            By submitting this form, you are consenting to receive marketing emails from: Sports Management Worldwide, 500 Ala Moana Building 7, Suite 400, www.smww.com,  Honolulu, Hawaii 96813 , US, http://www.sportsmanagementworldwide.com. You can revoke your consent to receive emails at any time by using the SafeUnsubscribe® link, found at the bottom of every email.
                                                            <a href="https://www.constantcontact.com/legal/service-provider" target="_blank" rel="”noopener" noreferrer="" className="ctct-form-footer-link">Emails are serviced by Constant Contact.</a>
                                                            
                                                        </p>
                                                    </div>

                                                    <button data-qe-id="form-button" type="submit" class="ctct-form-button">Sign Up!</button>

                                                    {/* <div class="g-recaptcha" id="ctct_recaptcha_2" data-sitekey="6LfHrSkUAAAAAPnKk5cT6JuKlKPzbwyTYuO8--Vr" data-size="invisible"><div class="grecaptcha-badge" data-style="bottomright" style="width: 256px; height: 60px; display: block; transition: right 0.3s; position: fixed; bottom: 14px; right: -186px; box-shadow: gray 0px 0px 5px; border-radius: 2px; overflow: hidden;"><div class="grecaptcha-logo"><iframe title="reCAPTCHA" width="256" height="60" role="presentation" name="a-41ztmb95wpj3" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation" src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LfHrSkUAAAAAPnKk5cT6JuKlKPzbwyTYuO8--Vr&amp;co=aHR0cHM6Ly93d3cuc213d2FnZW5jeS5jb206NDQz&amp;hl=en&amp;v=jdMmXeCQEkPbnFDy9T04NbgJ&amp;size=invisible&amp;anchor-ms=20000&amp;execute-ms=15000&amp;cb=d7ucy6a327z4"></iframe></div><div class="grecaptcha-error"></div><textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response" style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea></div><iframe style="display: none;"></iframe></div> */}
                                                </form>
                                                )}
                                                <p class="ctct-form-footer">
                                                    
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* End Constant Contact Inline Form Code  */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{clear: "both"}}></div>
                    <div class="social-share container ds smw-st-blog">
                        <div class="row">
                            <div class="column1">
                                <span style={{"color":"#003c7d","fontSize":"15px"}}><b>SHARE</b></span>
                            </div>
                            <div class="column2">
                                <a target="_blank" href={socialMediaShare.facebookUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}><img src="/basic/web/images/fb_blog_red.png"/></a>
                                <a target="_blank" href={socialMediaShare.linkedinUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}><img src="/basic/web/images/linkedin_blog_red.png"/></a>
                                <a target="_blank" href={socialMediaShare.twitterUrl + configData.RSMWW_AGENCY_URL + mainNewsContent.shareUrl}><img src="/basic/web/images/twitter_blog_red.png"/></a>
                            </div>
                            <div class="column3">
                                <a href={configData.AGENCY_DOMAIN_URL+"/smww-agency-news"}><button id="back_button" class="button mr-1 arrow" type="button">Back</button></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right"></div>
            </div>
        )}
        </>
    );
};
export default AgencyNewsContent;
